export const EDDA_MIN_DAILY_TRANSACTION_AMOUNT_HKD = 500
export const EDDA_MAX_DAILY_TRANSACTION_AMOUNT_HKD = 20000
export default 0
